import * as busyIndicator from "client_legacy/ndaw/busyIndicator";
import { AlertManager } from "client/Hooks";
import { environmentHttpClient } from "client/Api/httpClient";
import { localize } from "client_legacy/ndaw/culture";
import { openExternalUrlConfirmationDialog } from "./ExternalUrlConfirmationDialog/ExternalUrlConfirmationDialog";
import { isValidUrl } from "client/Misc/findUrlsInText";
import { isNil } from "client/Misc/utils";

export async function openUrlFile(
	url: string,
	alertManager: AlertManager
): Promise<void> {
	try {
		busyIndicator.show("body");

		const fileContent: string = await environmentHttpClient.getText(url);

		busyIndicator.hide("body");

		const fileContentResult: TryResult<string> = tryParseUrlFile(fileContent);

		if (!fileContentResult.wasSuccessful) {
			alertManager.showError(
				localize("_GeneralErrorMessage")
			);
			return;
		}

		openExternalUrlConfirmationDialog(fileContentResult.result);
	} catch (e) {
		console.error(e);
		busyIndicator.hide("body");
		alertManager.showError(
			localize("_GeneralErrorMessage")
		);
	}
}

export function tryParseUrlFile(fileContent: string): TryResult<string> {
	const match: RegExpMatchArray | null = fileContent.match(/URL=(.*)/i);

	if (isNil(match) || match.length < 2) {
		return {
			wasSuccessful: false
		};
	}

	const url: string = match[1].trim();

	if (!isValidUrl(url)) {
		return {
			wasSuccessful: false
		};
	}

	return {
		wasSuccessful: true,
		result: url
	};
}
